export const testimonials = [
  {
    text: `"This product has revolutionized the way we work. The team absolutely loves it!"`,
    name: "Sarah Johnson",
    role: "Product Manager at Spotify",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    text: `"The customer service is outstanding! They were there every step of the way to ensure we had everything we needed."`,
    name: "James Williams",
    role: "CEO at Amazon",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    text: `"We saw a 40% increase in productivity after implementing this solution. Highly recommend!"`,
    name: "Patricia Taylor",
    role: "Operations Director at Netflix",
    image: "https://randomuser.me/api/portraits/women/68.jpg",
  },
  {
    text: `"An incredible product! It has made our workflow so much more efficient and streamlined."`,
    name: "Michael Brown",
    role: "CTO at Facebook",
    image: "https://randomuser.me/api/portraits/men/83.jpg",
  },
  {
    text: `"I cannot say enough good things about this service. It has exceeded all of our expectations."`,
    name: "Jennifer Davis",
    role: "Marketing Lead at Airbnb",
    image: "https://randomuser.me/api/portraits/women/29.jpg",
  },
];
